import BaseComponent from '../base-component/base-component'
import { Nullable } from '../../types/common'

class SearchField extends BaseComponent {
  inputSelector: string
  resetBtnSelector: string
  input: Nullable<HTMLInputElement>
  resetBtn: Nullable<HTMLElement>

  constructor() {
    super()

    this.inputSelector = `[data-search-field-input]`
    this.resetBtnSelector = `[data-search-field-reset-button]`

    this.input = this.querySelector(this.inputSelector)
    this.resetBtn = this.querySelector(this.resetBtnSelector)
  }

  connectedCallback(): void {
    this.input.addEventListener('input', this.handleInputChange)
    window.addEventListener('click', this.handleWindowClick)
    this.resetBtn.addEventListener('click', this.handleResetBtnClick)
  }

  disconnectedCallback(): void {
    this.input.removeEventListener('input', this.handleInputChange)
    window.removeEventListener('click', this.handleWindowClick)
    this.resetBtn.removeEventListener('click', this.handleResetBtnClick)
  }

  handleWindowClick = (event: MouseEvent): void => {
    const target = event.target as HTMLElement
    const isInputChild = target.closest('search-input')
    const isInput = this.input === target
    const isOutsideClick = !isInput && !isInputChild

    if (isOutsideClick) {
      this.updateResetButtonVisible()
    }
  }

  handleInputChange = (): void => {
    this.updateResetButtonVisible()
  }

  handleResetBtnClick = (event: MouseEvent): void => {
    event.preventDefault()

    this.reset()
  }

  reset(): void {
    if (this.input) {
      const event = new Event('input', { bubbles: true })

      this.input.value = ''

      this.input.dispatchEvent(event)

      this.input.focus()
    }
  }

  updateResetButtonVisible(): void {
    if (this.resetBtn) {
      const hasValue = this.hasInputValue()

      this.resetBtn.classList.toggle('hidden', !hasValue)
    }
  }

  hasInputValue(): boolean {
    if (!this.input) {
      return false
    }

    return this.input.value.trim().length > 0
  }

  get value(): string {
    if (!this.input) {
      return ''
    }

    return this.input.value
  }
}

export default SearchField
